import { fork, takeLatest } from 'redux-saga/effects';
import { updateOrttoUserWorker } from './sagaWorkers';
import { updateOrttoUser } from '../actionCreators';

const sagas = [fork(takeLatest, updateOrttoUser, updateOrttoUserWorker)];

export default sagas;
